import { render, staticRenderFns } from "./ed-customize-components-course.component.vue?vue&type=template&id=17302c0c&scoped=true&"
import script from "./ed-customize-components-course.component.ts?vue&type=script&lang=ts&"
export * from "./ed-customize-components-course.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-customize-components-course.component.scss?vue&type=style&index=0&id=17302c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17302c0c",
  null
  
)

export default component.exports